<template>
  <div>
    <Spinner v-if="isLoading" />
    <div v-else-if="getTransactionsError" class="notification-content">
      <Message :message="getTransactionsError.message" :icon="getTransactionsError.icon" />
    </div>
    <div v-else class="transactions-view">
      <div class="header-container" data-cy="header-container">
        <!-- <b-field label="Selecciona año" horizontal>
          <b-select
            id="select-year"
            v-model="selectedYear"
            :placeholder="`${currentYear}`"
            rounded>
            <option
              v-for="year in yearsFilter"
              :key="year"
              :value="year">
              {{ year }}
            </option>
          </b-select>
        </b-field> -->
        <span>Últimos pagos realizados</span>
        <b-dropdown
          id="filtro-pagos"
          v-model="selectedStatus"
          data-cy="filtro-pagos"
          position="is-bottom-right"
          append-to-body
          multiple
          :close-on-click="false"
          :mobile-modal="false"
          aria-role="list"
          @active-change="updateTransactionsHistory($event)">
          <template #trigger>
            <b-button
              rounded
              class="status-filter-button"
              type="is-button-secondary">
              <span class="icon is-small">
                <i class="fas fa-filter" />
              </span>
              <span>Filtrar</span>
            </b-button>
          </template>
          <b-dropdown-item
            v-for="(value, status) in dropdownItems"
            :id="value"
            :key="status"
            :value="value"
            aria-role="listitem">
            <span>{{ status }}</span>
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <div v-if="getTransactionsMessage" class="notification-content">
        <Message :message="getTransactionsMessage.message" :icon="getTransactionsMessage.icon" :as-card="false" />
      </div>
      <div v-else class="transactions-container" data-cy="transactions-container">
        <SingleTransaction
          v-for="transaction in transactions"
          :key="transaction._id"
          :current-user-is-client="currentUserIsClient"
          :is-extended="extendedTransaction === transaction._id"
          :transaction="transaction"
          @extend-transaction="extendTransaction" />
        <creditu-pagination
          v-if="!isLoading && numberOfDocuments > transactions.length"
          :page-number.sync="pageNumber"
          size="is-small"
          :documents-per-page.sync="documentsPerPage"
          items-name="Transacciones"
          :total="numberOfDocuments"
          :range-before="1"
          :range-after="1"
          :documents-per-page-options="[10, 20, 50]" />
      </div>
    </div>
  </div>
</template>
<script>
import SingleTransaction from '@/ui/components/internal/pay-here/SingleTransaction.vue';
import CredituPagination from '@/ui/components/CredituPagination.vue';
import Spinner from '@/ui/components/Spinner.vue';
import Message from '@/ui/components/Message.vue';
import { getTransactionsHistory } from '@/application/services/api-clients/transactions';

export default {
  components: { SingleTransaction, CredituPagination, Spinner, Message },
  props: {
    paymentProviders: { type: Array, default: () => [] },
    clientId: { type: String, default: '' },
    currentUserIsClient: { type: Boolean, default: false }
  },
  data() {
    const currentYear = new Date().getFullYear();
    return {
      currentYear,
      debtMessage: '',
      extendedTransaction: '',
      getTransactionsError: '',
      getTransactionsMessage: '',
      isLoading: false,
      selectedStatus: ['CONFIRMED,CONSIGNABLE', 'SUCCESS,PENDING'],
      // selectedYear: currentYear,
      statusDictionary: {
        REJECTED: 'Rechazado',
        FAIL: 'Fallido',
        CANCELLED: 'Cancelado',
        SUCCESS: 'En revisión',
        PENDING: 'En revisión',
        CONFIRMED: 'Pagado',
        CONSIGNABLE: 'Pagado'
      },
      transactions: [],
      documentsPerPage: 10,
      numberOfDocuments: 0,
      pageNumber: 1
    };
  },
  computed: {
    // calcular el primer año a partir del primer pago?
    // yearsFilter() {
    //   const years = [];
    //   for (let i = 2018; i <= this.currentYear; i += 1) {
    //     years.push(i);
    //   }
    //   return years;
    // },
    providersDictionary() {
      const providersToReturn = this.paymentProviders.reduce((acc, provider) => {
        acc[`${provider.slug}`] = provider.name;
        return acc;
      }, {});
      providersToReturn.undefined = 'Sin medio de pago';
      return providersToReturn;
    },
    dropdownItems() {
      const clientStatusTranslate = {
        Pagado: 'CONFIRMED,CONSIGNABLE',
        'En revisión': 'SUCCESS,PENDING'
      };
      const backOfficeStatusTranslate = {
        Pagado: 'CONFIRMED,CONSIGNABLE',
        'En revisión': 'SUCCESS,PENDING',
        Cancelado: 'CANCELLED',
        Fallido: 'FAIL',
        Rechazado: 'REJECTED'
      };
      return this.currentUserIsClient ? clientStatusTranslate : backOfficeStatusTranslate;
    }
  },
  watch: {
    async documentsPerPage() {
      this.pageNumber = 1;
      await this.getTransactionsHistory(this.pageNumber);
    },
    pageNumber: {
      immediate: true,
      async handler() {
        await this.getTransactionsHistory(this.pageNumber);
      }
    },
    transactions: {
      depp: true,
      handler() {
        if (this.transactions.length > 0) {
          this.transactions.forEach((transaction, index) => {
            this.transactions[index].statusTranslation = this.statusDictionary[transaction.status];
            this.transactions[index].providerTranslation = this.providersDictionary[transaction.provider];
          });
        }
      }
    }
    // async selectedYear() {
    //   await this.getTransactionsHistory();
    // }
  },
  methods: {
    async updateTransactionsHistory(active) {
      if (!active) {
        if (this.selectedStatus.length === 0) {
          this.getTransactionsMessage = {
            message: 'No hay pagos para mostrar. Prueba seleccionando otro filtro.',
            icon: 'sin-cuotas-pendientes.svg'
          };
        } else {
          await this.getTransactionsHistory(1);
        }
      }
    },
    async getTransactionsHistory(selectedPageNumber) {
      this.isLoading = true;
      this.getTransactionsMessage = '';
      this.getTransactionsError = '';
      try {
        const getFilter = {
          clientId: this.clientId,
          status: this.selectedStatus.filter(status => status).join()
        };
        const getPage = {
          size: this.documentsPerPage,
          number: selectedPageNumber
        };
        const { data: { data: transactions, meta: { page } } } = await getTransactionsHistory(getFilter, getPage, '-createdAt');
        this.transactions = transactions;
        this.pageNumber = page.number;
        this.numberOfDocuments = page.total;
      } catch (error) {
        if (error.response) {
          if (error.response.status === 404) {
            this.getTransactionsMessage = {
              message: 'No hay pagos para mostrar. Prueba seleccionando otro filtro.',
              icon: 'sin-cuotas-pendientes.svg'
            };
          } else {
            this.getTransactionsMessage = {
              message: 'Ocurrió un error tratando de obtener el historial de pagos',
              icon: 'data_maintenance.svg'
            };
          }
        } else {
          this.getTransactionsError = {
            message: 'Ocurrió un error tratando de obtener el historial de pagos',
            icon: 'data_maintenance.svg'
          };
        }
      }
      this.isLoading = false;
    },
    extendTransaction(transactionId) {
      this.extendedTransaction = this.extendedTransaction === transactionId ? '' : transactionId;
    }
  }
};
</script>
<style scoped>
  .card-item {
    overflow: visible;
  }
  .transactions-view {
    display: flex;
    flex-flow: column wrap;
    align-items: center;
    align-content: center;
    gap: 2rem;
  }
  .header-container {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex start;
    align-items: center;
    width: 100%;
    gap: 2rem;
  }
  .transactions-container {
    display: flex;
    flex-flow: column wrap;
    gap: 1.5rem;
    width: 100%;
  }
  @media (max-width: 400px) {
  .header-container {
    justify-content: center;
    gap: 1rem;
  }
}
</style>
